import DropdownIcon from "@ancon/wildcat-ui/web/orderweb/DropdownIcon";
import "@ancon/wildcat-ui/web/orderweb/DropdownIcon/DropdownIcon.css";

export default DropdownIcon;
